import { render, staticRenderFns } from "./InlineLoader.vue?vue&type=template&id=2235a1c2&scoped=true"
import script from "./InlineLoader.vue?vue&type=script&lang=js"
export * from "./InlineLoader.vue?vue&type=script&lang=js"
import style0 from "./InlineLoader.vue?vue&type=style&index=0&id=2235a1c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2235a1c2",
  null
  
)

export default component.exports